// Shared constants for the GKE tiers, which serve tenants on {tenant}.shadow.valeriehealth.com.

export const GKE_RETURN_COOKIE = "__gke_return";

// Matches a full GKE tenant host, e.g. balance-health.shadow.valeriehealth.com.
export const GKE_HOST_PATTERN = /^[a-z0-9-]+\.shadow\.valeriehealth\.com$/;
